export default __webpack_public_path__ + "static/media/blur.2554756c.frag";